export default __webpack_public_path__ + "static/media/Arch_AWS-CodeCommit_64.26f08ede.svg";